import useSEO from "@/hooks/useSEO";
import { Headphones } from "lucide-react";
import { PageHero, Reveal } from "@/components/ui-lux";

const LINKS = [
  ["Listen on Apple Podcasts", "https://podcasts.apple.com/us/podcast/todd-coconato-show-the-transformed-mind-experience/id1528647734", "apple"],
  ["Listen on Spotify", "https://open.spotify.com/show/2F02Qod8akLsCFi7hFS9zi", "spotify"],
];

const PLAYER = "https://www.podbean.com/player-v2/?i=3u799-19611e-pbblog-playlist&share=1&download=1&rtl=0&fonts=Arial&skin=1&font-color=auto&logo_link=episode_page&order=episodic&limit=10&filter=all&ss=a713390a017602015775e868a2cf26b0&btn-skin=1b1b1b&size=315";

export default function Podcast() {
  useSEO({ title: "Podcast", description: "Listen to the Todd Coconato Show | The Transformed Mind Experience podcast." });
  return (
    <div data-testid="podcast-page">
      <PageHero eyebrow="Podcast" title="The Todd Coconato Show." sub="The Transformed Mind Experience. Faith-filled conversations to renew your thinking wherever you are." image="/images/todd-stadium.jpg" />
      <div className="container-x max-w-4xl">
        <Reveal>
          <div className="card-lux p-4 sm:p-6" data-testid="podcast-player">
            <iframe title="Todd Coconato Show | The Transformed Mind Experience" src={PLAYER} height="315" width="100%" scrolling="no" loading="lazy" allowFullScreen
              data-name="pb-iframe-player" style={{ border: "none", minWidth: "min(100%, 430px)", height: 315 }} />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10" data-testid="podcast-subscribe">
            <span className="text-sm text-slate-400">Follow the show:</span>
            {LINKS.map(([label, href, key], i) => (
              <a key={key} href={href} target="_blank" rel="noopener noreferrer" className={i ? "btn-outline" : "btn-gold"} data-testid={`podcast-${key}-btn`}><Headphones size={16} /> {label}</a>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
